import React, { FunctionComponent } from "react";
import { Tooltip, TooltipVariant } from '../Tooltip';
import { List, ListItemVariant } from '../List';
import cls from '../utils/classnames';
import { CHECKBOX, CHECKBOX_LABEL, CHECKBOX_ELEMENT } from '../utils/classes';
import './_styles.scss';

export type TooltipPosition = 'left' | 'right' | 'top' | 'bottom';

export interface ICheckboxProps {
  label?: string;
  name?: string;
  checked?: boolean;
  onChange?: (e: any) => void;
  removeStyle?: () => void;
  variant?: string;
  title?: string;
  checkList?: any;
  showTooltip?: boolean;
}

export const Checkbox: FunctionComponent<ICheckboxProps> = props => {
  const { label, name, checked, onChange, removeStyle, variant, title, checkList, showTooltip } = props;
  return (
    <div className={CHECKBOX} onFocus={removeStyle}>
      <a className={cls('aaf_button-default', 'focusable', `${CHECKBOX_ELEMENT}`)} data-checked={checked} id={name} name={name} href="javascript:void(0)"
         tabIndex={0} onClick={(event: React.SyntheticEvent<EventTarget>) => {
        let {target: {dataset: {checked = 'false'}}} = event;
        event.preventDefault();
        checked = checked === 'false' ? 'true' : 'false';
        if (onChange) {
          onChange(checked === 'true');
        }
      }}></a>
      <label className={`${CHECKBOX_LABEL}`}>{label}</label>
      {showTooltip && <Tooltip
        variant={variant as TooltipVariant}
        title={title}
      >
        <List variant={variant as ListItemVariant} items={checkList} />
      </Tooltip>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Checkbox/index.tsx